import React from 'react'
import PropTypes from 'prop-types'
import './styles/index.css'


const TitleHeader = props => (
  <p className="header">{props.title}</p>
)

TitleHeader.propTypes = {
  title: PropTypes.string
}

TitleHeader.defaultProps = {
  title: ''
}

export default TitleHeader



// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/MobileCarousel/Header.js